import { refreshImagePreview } from "./common";
import { updateBigCookie } from "./updateBigCookie";
export const applySettings = () => {
    refreshImagePreview();
    updateBigCookie();
};
